import * as CONFIG from 'config';
import defaultCss from './default.module.css';
import css from 'styles/Navigations.module.css';
import classnames from 'classnames/bind';
import { useContext } from 'react';
import { CatalogContext } from 'Catalog/Catalog.context';
import CatalogLink from 'Catalog/CatalogLink';
import { PrevButton, NextButton } from 'Catalog/PagingButtons';
import AutoplayButton from 'Catalog/AutoplayButton';

const cx = classnames.bind(css);

export default function Navigations() {
  return (
    <div className={defaultCss.container}>
      <Header />
      <Controller />
    </div>
  );
}

function Header() {
  const { activePageInfo, lang, pageNum } = useContext(CatalogContext);

  const gnbMap = [
    { label: { ko: '하이원 리조트', en: 'High1 Resort', cn: 'High1 度假村' }, href: '4' },
    { label: { ko: '연회시설', en: 'Banquet / convention facilities', cn: '宴会设施' }, href: '5' },
    { label: { ko: '하이원 스키', en: 'High1 Ski', cn: 'High 1 滑雪' }, href: '6' },
    { label: { ko: '호텔 & 콘도', en: 'Hotel & Condominium Accommodations', cn: '酒店 & 度假村' }, href: '7' },
    { label: { ko: '액티비티 & 식음시설', en: 'Recreational & Amenities', cn: '活动与餐饮设施' }, href: '8' },
  ];

  if (!activePageInfo || !lang) {
    return null;
  }

  return (
    <header className={cx('header', `theme--${activePageInfo.headerTheme}`)}>
      <div className={cx('layer', 'layer-default')}>
        <CatalogLink
          to='1'
          className={cx('logo')}
        >
          <img
            src={`${CONFIG.IMG_URL}/common/kangwonland-logo-white.png`}
            alt=''
            className={cx('white')}
          />
          <img
            src={`${CONFIG.IMG_URL}/common/kangwonland-logo-colored.png`}
            alt=''
            className={cx('colored')}
          />
        </CatalogLink>
        <nav className={cx('etc')}>
          <div className={cx('lang-nav')}>
            <CatalogLink
              to={`/ko/1`}
              type='absolute'
              className={cx('lang-btn', { active: lang === 'ko' })}
            >
              KR
            </CatalogLink>
            <CatalogLink
              to={`/en/1`}
              type='absolute'
              className={cx('lang-btn', { active: lang === 'en' })}
            >
              EN
            </CatalogLink>
            <CatalogLink
              to={`/cn/1`}
              type='absolute'
              className={cx('lang-btn', { active: lang === 'cn' })}
            >
              CN
            </CatalogLink>
          </div>
          <CatalogLink
            to='3'
            className={cx('btn', 'btn-index')}
          >
            <span></span>
            <span></span>
            <span></span>
          </CatalogLink>
          <AutoplayButton className={cx('btn', 'btn-autoplay')}>
            <span className={cx('icon', 'arrow', 'right')}></span>
          </AutoplayButton>
        </nav>
      </div>
      <div className={cx('layer', 'layer-gnb', { show: activePageInfo.gnbState === 'show' })}>
        <nav className={cx('gnb')}>
          {gnbMap.map((gnb, i) => (
            <CatalogLink
              key={`gnb-item-${i}`}
              to={gnb.href}
              className={cx('gnb-item', { active: pageNum == gnb.href })}
            >
              {gnb.label[lang]}
            </CatalogLink>
          ))}
        </nav>
      </div>
    </header>
  );
}

function Controller() {
  const { pageNum, pageTotal } = useContext(CatalogContext);
  return (
    <nav className={cx('controller')}>
      <PrevButton className={cx('btn', 'prev', { disabled: pageNum === 1 })}>
        <i className={cx('icon', 'arrow', 'left')}></i>
      </PrevButton>
      <CatalogLink
        to='3'
        className={cx('idx', 'btn')}
      >
        <span></span>
        <span></span>
        <span></span>
      </CatalogLink>
      <NextButton className={cx('btn', 'next', { disabled: pageNum === pageTotal })}>
        <i className={cx('icon', 'arrow', 'right')}></i>
      </NextButton>
    </nav>
  );
}
